import { render } from "./MrentedvehiclesView.vue?vue&type=template&id=7534a8a4&scoped=true"
import script from "./MrentedvehiclesView.vue?vue&type=script&lang=js"
export * from "./MrentedvehiclesView.vue?vue&type=script&lang=js"

import "./MrentedvehiclesView.vue?vue&type=style&index=0&id=7534a8a4&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\vrs_yii2_new\\vuejs\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7534a8a4"]])

export default __exports__